import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { cn } from "@/lib/utils";

const AnimatedLogo = ({ className, offset = ["start end", "end start"] }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: offset,
  });

  const fillOpacity = useTransform(scrollYProgress, [0, 1], [0.7, 1]);
  const y = useTransform(scrollYProgress, [0, 1], [100, 0]);
  // const rotate = useTransform(scrollYProgress, [0, 1], [0, 40]);
  // const pathLength = useTransform(scrollYProgress, [0, 1], [0, 1]);
  // const strokeOpacity = useTransform(scrollYProgress, [0, 1], [1, 1]);

  const style = {
    fillOpacity,
    stroke: "currentColor", // Ensure stroke color is applied
    // pathLength,
    // strokeOpacity,
    // strokeWidth: 4,
    strokeWidth: 0,
    // rotate,
  };

  return (
    <div ref={ref} className={cn(className, "[--animate-y:0px] lg:[--animate-y:40px]")}>
      <motion.svg viewBox="0 0 375 372" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ y }}>
        <motion.path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M175.562 9.9197C175.562 4.92121 179.614 0.869141 184.612 0.869141C189.611 0.869141 193.663 4.92122 193.663 9.91971V149.205L236.821 74.4537L252.497 83.5043L209.746 157.551L335.077 85.1907C339.406 82.6915 344.941 84.1746 347.44 88.5034C349.94 92.8323 348.456 98.3675 344.128 100.867L219.769 172.665H308.246V190.766H219.469L344.221 262.792C348.55 265.291 350.033 270.826 347.534 275.155C345.034 279.484 339.499 280.967 335.17 278.468L207.622 204.828L252.57 282.681L236.894 291.731L193.663 216.852V362.892C193.663 367.89 189.611 371.942 184.612 371.942C179.614 371.942 175.562 367.89 175.562 362.892V216.759L133.331 289.905L117.655 280.855L160.293 207.004L38.4448 277.353C34.116 279.852 28.5808 278.369 26.0815 274.04C23.5823 269.711 25.0655 264.176 29.3943 261.677L152.215 190.766H69.9145V172.665H151.915L29.4876 101.982C25.1588 99.4825 23.6756 93.9473 26.1748 89.6185C28.6741 85.2897 34.2093 83.8065 38.5381 86.3057L158.169 155.374L117.729 85.3301L133.405 76.2795L175.562 149.298V9.9197ZM251.917 48.3276L267.593 57.3782L281.168 33.8641C283.668 29.5353 282.184 24.0001 277.856 21.5008C273.527 19.0016 267.992 20.4847 265.492 24.8135L251.917 48.3276ZM89.0777 35.7399C86.5785 31.4111 88.0616 25.8759 92.3904 23.3766C96.7193 20.8774 102.255 22.3605 104.754 26.6893L118.33 50.2034L102.654 59.254L89.0777 35.7399ZM267.712 308.813L252.036 317.863L265.612 341.377C268.111 345.706 273.646 347.189 277.975 344.69C282.304 342.191 283.787 336.655 281.288 332.327L267.712 308.813ZM12.6306 190.766C7.63215 190.766 3.58008 186.714 3.58008 181.716C3.58008 176.717 7.63215 172.665 12.6306 172.665H39.7823V190.766H12.6306ZM338.432 172.665H365.584C370.582 172.665 374.634 176.717 374.634 181.716C374.634 186.714 370.582 190.766 365.584 190.766H338.432V172.665ZM92.3284 342.871C96.6573 345.37 102.192 343.887 104.692 339.558L118.268 316.044L102.592 306.994L89.0157 330.508C86.5165 334.837 87.9996 340.372 92.3284 342.871ZM184.574 207.507C198.736 207.507 210.217 196.026 210.217 181.864C210.217 167.701 198.736 156.22 184.574 156.22C170.412 156.22 158.931 167.701 158.931 181.864C158.931 196.026 170.412 207.507 184.574 207.507Z"
          fill="currentColor"
          style={style}
        />
      </motion.svg>
    </div>
  );
};

export default AnimatedLogo;
